import React from "react";
import {
  Box,
  Card,
  CardContent,
  Stack,
  Typography,
  Chip,
  Divider,
} from "@mui/material";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

const ROLE_DESCRIPTIONS = [
  {
    role: "Admin",
    summary:
      "Full organization administration. Manages users, territories, settings, and operational workflows. Can create, edit, and delete any information in the CRM. Role is limited to 1 user only.",
  },
  {
    role: "Sales Director",
    summary:
      "Organization-level leadership access for sales operations and reporting, with broad visibility across teams. Admin-like access but cannot delete any information, and cannot modify integrations or subscriptions of your account.",
  },
  {
    role: "Manager",
    summary:
      "Territory/team management access. Oversees assigned team activity and lead execution within managed scope. Can add and read all leads in assigned territory. No settings visibility. Cannot delete any lead information.",
  },
  {
    role: "Sales Rep",
    summary:
      "Frontline role focused on assigned leads, follow-ups, and daily pipeline execution. Can view and edit their own assigned leads only. Settings are not visible to this user",
  },
];

export default function RolesReadOnlyPage() {
  return (
    <Box sx={{ p: 3, px: { xs: 1, sm: 3 } }}>
      <Box sx={{ maxWidth: 1200, mx: "auto", width: "100%" }}>
        <Card sx={{ p: 3, mb: 3, borderRadius: 3 }}>
          <Stack direction="row" spacing={2} alignItems="center">
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: (theme) =>
                  theme.palette.mode === "dark"
                    ? "rgba(255,255,255,0.08)"
                    : "rgba(25,118,210,0.08)",
              }}
            >
              <AdminPanelSettingsIcon color="primary" />
            </Box>
            <Box>
              <Typography variant="h6" fontWeight={700}>
                Roles & Groups
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Read-only reference for role access across the CRM.
              </Typography>
            </Box>
          </Stack>
        </Card>

        <Card
          data-tour="roles-overview"
          sx={{ borderRadius: 3, boxShadow: "0 10px 30px rgba(0,0,0,0.08)" }}
        >
          <CardContent sx={{ p: 0 }}>
            {ROLE_DESCRIPTIONS.map((item, idx) => (
              <Box key={item.role}>
                <Box sx={{ p: 2.5 }}>
                  <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                    <Chip label={item.role} color="primary" size="small" />
                  </Stack>
                  <Typography variant="body2" color="text.secondary">
                    {item.summary}
                  </Typography>
                </Box>
                {idx < ROLE_DESCRIPTIONS.length - 1 ? <Divider /> : null}
              </Box>
            ))}
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}
